import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ButtonStyleTypes } from '../../atoms/buttons/enums.js';
import { setDataAttributes, isRTL, getContainerClass } from '../../utilities/dom-helpers/index.js';
import { setLineClamp } from '../../utilities/text-helpers/index.js';
import css_248z$1 from './styles/groupsite-icon-and-info.scss.js';
import css_248z from './styles/icon-and-info.scss.js';

class IconAndInfo extends s {
    constructor() {
        super(...arguments);
        this.styleType = ButtonStyleTypes.LIGHT;
        this.rtl = false;
        this.roundIcon = false;
        this.headingSlot = null;
        this.textSlot = null;
        this.size = '';
        this.isIcon = false;
        this.isThreeCols = false;
        this.isFourCols = false;
        this.templateType = 'classic';
        this.enableShadow = false;
        this.background = 'default';
        this.iconBorder = 'none';
        this.iconTitleColor = 'black';
        this.iconTextColor = 'black';
        this.iconTitleSize = 'Small';
        this.iconTextSize = 'Small';
        this._initialized = false;
    }
    firstUpdated() {
        if (!this._initialized) {
            this._initialized = true;
            setDataAttributes(this, 'heading', 'text');
            setLineClamp(this, 99, 299);
        }
    }
    getIconTitleColor() {
        return this.styleType !== ButtonStyleTypes.DARK ? `icon-title-color-${this.iconTitleColor}` : '';
    }
    ;
    getIconTextColor() {
        return this.styleType !== ButtonStyleTypes.DARK ? `icon-text-color-${this.iconTextColor}` : '';
    }
    ;
    render() {
        var _a, _b;
        const iconHeadingColor = this.getIconTitleColor();
        const iconTextColor = this.getIconTextColor();
        const classes = {
            [this.styleType]: this.styleType,
            rtl: this.rtl || isRTL(),
            'icon-and-info-container': true,
            lighthouse: this.templateType === 'lighthouse',
            shadow: this.enableShadow,
            'background-white': this.background === 'white',
            [iconHeadingColor]: true,
            [iconTextColor]: true,
            [`icon-title-size-${(_a = this.iconTitleSize) === null || _a === void 0 ? void 0 : _a.toLowerCase()}`]: true,
            [`icon-text-size-${(_b = this.iconTextSize) === null || _b === void 0 ? void 0 : _b.toLowerCase()}`]: true
        };
        const modeDarkBorder = this.styleType === ButtonStyleTypes.DARK
            ? 'border: 6px solid white; background: linear-gradient(95.78deg, #6f2595, #aa0061)'
            : '';
        const renderIconClass = () => this.templateType === 'lighthouse'
            ? 'lighthouse-icon'
            : getContainerClass(this.isIcon, this.size);
        const getBorderClass = () => {
            if (this.styleType === ButtonStyleTypes.DARK)
                return '';
            if (this.iconBorder === 'burgundy'
                || this.iconBorder === 'purple')
                return `icon-border-${this.iconBorder}`;
            return 'icon-border-none';
        };
        return $ `<div class="${o(classes)}"><div style="${modeDarkBorder}" class="${renderIconClass()} ${getBorderClass()}"><slot name="icon"></slot></div><slot name="heading"></slot><slot name="text"></slot><slot name="cta"></slot></div>`;
    }
}
IconAndInfo.styles = [css_248z, css_248z$1];
__decorate([
    e({ type: String })
], IconAndInfo.prototype, "styleType", void 0);
__decorate([
    e({ type: Boolean })
], IconAndInfo.prototype, "rtl", void 0);
__decorate([
    e({ type: Boolean })
], IconAndInfo.prototype, "roundIcon", void 0);
__decorate([
    t()
], IconAndInfo.prototype, "headingSlot", void 0);
__decorate([
    t()
], IconAndInfo.prototype, "textSlot", void 0);
__decorate([
    e({ type: String })
], IconAndInfo.prototype, "size", void 0);
__decorate([
    e({ type: Boolean })
], IconAndInfo.prototype, "isIcon", void 0);
__decorate([
    e({ type: Boolean })
], IconAndInfo.prototype, "isThreeCols", void 0);
__decorate([
    e({ type: Boolean })
], IconAndInfo.prototype, "isFourCols", void 0);
__decorate([
    e({ type: String })
], IconAndInfo.prototype, "templateType", void 0);
__decorate([
    e({ type: Boolean })
], IconAndInfo.prototype, "enableShadow", void 0);
__decorate([
    e({ type: String })
], IconAndInfo.prototype, "background", void 0);
__decorate([
    e({ type: String })
], IconAndInfo.prototype, "iconBorder", void 0);
__decorate([
    e({ type: String })
], IconAndInfo.prototype, "iconTitleColor", void 0);
__decorate([
    e({ type: String })
], IconAndInfo.prototype, "iconTextColor", void 0);
__decorate([
    e({ type: String })
], IconAndInfo.prototype, "iconTitleSize", void 0);
__decorate([
    e({ type: String })
], IconAndInfo.prototype, "iconTextSize", void 0);
customElements.define('icon-and-info', IconAndInfo);

export { IconAndInfo };
